import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const PAYMENT_API_URL = process.env.REACT_APP_PAYMENT_API_URL;
const HANDSFREE_URL = process.env.REACT_APP_ENDPOINT_HANDSFREE_APP_API_URL;


export default {
  async GetStats(data) {
    try {
      const token = localStorage.getItem('tokenForService');
      return axios({
        method: 'post',
        url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_ANALYTICS_GET_GENERAL}`,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        data: data,
      });
    } catch (error) {
      console.error('Error in GetStats:', error);
      throw error;
    }
  },
  async CreateOrder(array) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_MALL_LOGISTICS_CREATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: array,
    });
  },

  Login(username, password) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_LOGIN}`,
      data: {
        username: username,
        password: password,
      },
    });
  },

  ForgotPassword(username) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FORGET_PASSWORD}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        username: username,
      },
    });
  },

  GetLocation(token, branchID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_LOCATIONS_GET_LOCATIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        branchID: branchID,
      },
    });
  },

  GetPosts(token, status) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_POSTS_GET}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: status,
        withPosts: true,
        limit: 10000,
      },
    });
  },

  GetPostByOnlyBarcode(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_POST_SEARCH_BARCODE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: [barcode],
        withLogs: true,
      },
    });
  },
    // --- Posta kodu servisleri ---
  // Kullanan taraf: src/utils/postalCodes.js
  // Tüm yanıtlar { status, result: { items: [...], count } } biçiminde döner.

  // Posta kodu araması. prefix / city / region opsiyoneldir ve önek eşleşir,
  // birlikte kullanılabilir. Varsayılan limit 50, en fazla 500.
  SearchPostalCodes({ countryCode, prefix, city, region, limit = 50 }) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/postal-codes-search`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { countryCode, prefix, city, region, limit },
    });
  },

  // DHL Address Validate: yazılan harflerle başlayan, DHL'in tanıdığı şehirleri döndürür
  // ("Dub" -> DUBAI, DUBAI HILLS ...). type: pickup (gönderici) | delivery (alıcı).
  // Eşleşme yoksa status: false döner.
  DHLValidateAddress({ type, countryCode, cityName }) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/dhl-validate-address`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { type, countryCode, cityName },
    });
  },

  // Şehir/semt listesi. region ve search opsiyonel. Varsayılan limit 200.
  GetPostalCodeCities({ countryCode, region, search, limit = 200 }) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/postal-codes-get-cities`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { countryCode, region, search, limit },
    });
  },

  // Posta kodu verisi bulunan ülkeler.
  GetPostalCodeCountries() {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/postal-codes-get-countries`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {},
    });
  },
  // Birden fazla barkodu tek istekte sorgular; her kayıt kendi barcode alanıyla döner.
  SearchPostsByBarcodes(token, barcodes, withLogs = false) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/post-search-barcode`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcodes,
        withLogs,
      },
    });
  },

  GetArasKargoEcommerceCompanyList(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_ARAS_KARGO_DB_ECOMMERCE_COMPANY_LIST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  SetInBranch(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_POSTS_SET_IN_BRANCH}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: [postID],
      },
    });
  },

  TrendyolDropOffSetInBranch(token, postID, preprintedBarcode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_POSTS_SET_IN_BRANCH}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: [postID],
        preprintedBarcode,
      },
    });
  },

  PostComplete(token, barcode, otpType, otp) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_POSTS_COMPLETE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
        otpType: otpType,
        otp: otp,
      },
    });
  },

  PostCompleteForDHL(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_POSTS_COMPLETE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID,
      },
    });
  },

  PostCompleteByID(token, postID, otpType, otp) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_POSTS_COMPLETE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
        otpType: otpType,
        otp: otp,
      },
    });
  },

  PostReturn(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_POST_RETURN_COMPLETE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
      },
    });
  },

  GetUsers(token, status) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_USERS_GET_USERS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: status,
        withAuthOffices: true,
      },
    });
  },

  GetResponsibleRegions(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-point-districts`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  SaveRegion(token, regionData) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/create-point-district`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: regionData,
    });
  },
  UpdateRegion(token, regionData) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/update-point-district`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: regionData,
    });
  },
  RemoveRegion(token, id) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/remove-point-district`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id,
      },
    });
  },

  GetUser(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_USERS_GET_USER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
        withAuthOffices: true,
      },
    });
  },

  CreateTicket(token, title, description, type, files, username) {
    //console.log(token, title, description, type, files, username, '--------');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_SUPPORT_CREATE_TICKET}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        description: description,
        files: files,
        type: type,
        username: username,
      },
    });
  },

  GetUserByID(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_USERS_GET_USER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  GetUserForTickets(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_USERS_GET_USER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  GetTickets(token, status) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_TICKETS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: status,
      },
    });
  },

  GetTicketsUser(token, createdBy) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_TICKETS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        createdBy: createdBy,
      },
    });
  },

  GetTicketsStaff(token, responsibleBy) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_TICKETS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        responsibleBy: responsibleBy,
        status: 3,
        operator: 'or',
      },
    });
  },

  GetTicketsManager(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_TICKETS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: [1, 3, 4],
      },
    });
  },

  GetTicket(token, id) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_TICKET}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id: id,
      },
    });
  },

  GetTicketsByUser(token, createdBy) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_TICKETS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        createdBy: createdBy,
      },
    });
  },

  CreateTicketForPostDetail(token, title, description) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_SUPPORT_CREATE_TICKET}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        description: description,
        files: [],
        type: 'EasyNet',
      },
    });
  },

  ResendCode(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_POST_RECREATE_DELIVER_PASSWORD}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
      },
    });
  },

  GetUserTypes(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_USERS_GET_TYPES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetPoints(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_POINTS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  GetWebsitePoints() {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_WEBSITE_POINTS}`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  CreateEmployee(token, user) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_USERS_CREATE_EMPLOYEE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: user,
    });
  },

  UpdateProfile(token, user) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_USERS_UPDATE_PROFILE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: user,
    });
  },

  EditPassword(password, token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_USERS_UPDATE_PROFILE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        password: password,
      },
    });
  },

  GetSurvey(surveyID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_SURVEYS}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        surveyID,
      },
    });
  },

  GetAgreement(handle) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_AGREEMENTS_GET_AGREEMENT}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        agreementID: handle,
      },
    });
  },

  PostCancel(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_POSTS_CANCEL}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
      },
    });
  },
  GetCheckRooms(token, status, startDate, endDate, pointID) {
    // pointID eklendi
    const requestData = {
      status: status,
      startDate: startDate,
      endDate: endDate,
    };

    // Eğer pointID parametresi geldiyse ve boş değilse request'e ekle
    if (pointID) {
      requestData.pointID = pointID;
    }

    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CHECKROOM_GET}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: requestData,
    });
  },

  async GetPaymentTypes() {
    const token = localStorage.getItem('tokenForService');

    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_PAYMENTS_TYPES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  async FinancialGetEsnafInvoiceList(poiID, invoiceDate) {
    const token = localStorage.getItem('tokenForService');
    const data = {
      invoiceDate,
    };

    if (poiID) {
      data.poiID = poiID;
    }

    return axios({
      method: 'post',
      url: `${API_URL}flow/financial-get-esnaf-invoice-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  async getProdPrims(startDate, endDate, poiID) {
    const token = localStorage.getItem('tokenForService');
    const data = {
      startDate,
      endDate,
    };
    if (poiID) {
      data.poiID = poiID;
    }
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-esnaf-prims`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },

  async SetEsnafCutoff(invoiceID, amount) {
    const token = localStorage.getItem('tokenForService');
    const data = {
      invoiceID,
      amount,
    };
    return axios({
      method: 'post',
      url: `${API_URL}flow/financial-add-cut-off`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },

  async RemoveEsnafCutoff(cutOffID) {
    const token = localStorage.getItem('tokenForService');
    const data = {
      cutOffID,
    };
    return axios({
      method: 'post',
      url: `${API_URL}flow/financial-remove-cut-off`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data,
    });
  },
  async AddFinancialAdditionalPayment(invoiceID, amount, additionalNote, type) {
    const token = localStorage.getItem('tokenForService');
    const data = {
      invoiceID,
      amount,
      additionalNote,
      type,
    };
    return axios({
      method: 'post',
      url: `${API_URL}flow/financial-add-additional-payment`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  async RemoveFinancialAdditionalPayment(additionalPaymentID) {
    const token = localStorage.getItem('tokenForService');
    const data = {
      additionalPaymentID,
    };
    return axios({
      method: 'post',
      url: `${API_URL}flow/financial-remove-additional-payment`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  async FinancialMassInvoiceStatusUpdate(invoiceIDs, status) {
    const token = localStorage.getItem('tokenForService');
    const data = {
      invoiceIDs,
      status: String(status),
    };
    return axios({
      method: 'post',
      url: `${API_URL}flow/financial-mass-invoice-status-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  async FinancialUploadEsnafInvoice(poiID, invoiceDate, file, extension, invoiceID) {
    const token = localStorage.getItem('tokenForService');

    return axios({
      method: 'post',
      url: `${API_URL}flow/financial-upload-esnaf-invoice`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        poiID,
        invoiceDate,
        file: { file, extension },
        invoiceID,
      },
    });
  },

  SetPaymentStatus(token, postID, paymentType, invoiceID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_POST_SET_PAID}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
        paymentType: paymentType,
        invoiceID: invoiceID,
      },
    });
  },

  SendPanic(token, message) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_I_PANIC}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        message: message,
      },
    });
  },

  GetReport(token, queryType, startDate, endDate, filters = {}) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_REPORT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: 'auto',
        queryType: queryType,
        startDate: startDate,
        endDate: endDate,
        ...filters,
      },
    });
  },

  UserSetActive(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_USER_SET_ACTIVE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  UserSetPassive(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_USER_SET_PASSIVE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  GetStatistics(token, data) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_STATISTICS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  GetBolParaCompanies(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_BOL_PARA_COMPANIES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  BolParaAboutToken(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_ABOUT_TOKEN}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetBolParaCompanyCampaigns(token, companyID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_BOLPARA_CAMPAIGNS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID: companyID,
      },
    });
  },

  GetBolParaCampaign(token, campaignID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_BOLPARA_CAMPAIGN}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
      },
    });
  },

  CreateBolParaCompany(token, title, logo) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CREATE_BOL_PARA_COMPANY}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        logo: logo,
      },
    });
  },

  UpdateBolParaCompany(token, companyID, title, logo, status) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_UPDATE_BOL_PARA_COMPANY}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID: companyID,
        title: title,
        logo: logo,
        status: status,
      },
    });
  },

  UpdateBolParaCompanyBasedGetCouponButtonVisibleStatus(
    token,
    companyID,
    brandBasedGetCouponButtonVisibleStatus,
    title,
    status
  ) {
    console.log('Button Gösterme:', brandBasedGetCouponButtonVisibleStatus);
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_UPDATE_BOL_PARA_COMPANY}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        status: status,
        companyID,
        brandBasedGetCouponButtonVisibleStatus,
      },
    });
  },

  BolParaMassUpdateStatus(token, list) {
    console.log(list);
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_BOL_PARA_MASS_UPDATE_STATUS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        list: list,
      },
    });
  },

  CreateBolParaCampaign(
    token,
    title,
    prefix,
    companyID,
    description,
    images,
    start,
    end,
    type,
    allowedPoints,
    hasForm
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CREATE_BOL_PARA_CAMPAIGN}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        prefix: prefix,
        companyID: companyID,
        description: description,
        images: images,
        start: start,
        end: end,
        type: type,
        allowedPoints: allowedPoints,
        hasForm,
      },
    });
  },

  AddBolParaAgreement(token, campaignID, title, content) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_ADD_BOL_PARA_AGREEMENT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
        title: title,
        content: content,
      },
    });
  },

  GetBolParaAgreement(token, campaignID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_BOL_PARA_AGREEMENTS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
      },
    });
  },

  UpdateBolParaAgreement(token, agreementID, title, content) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_UPDATE_BOL_PARA_AGREEMENT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        agreementID: agreementID,
        title: title,
        content: content,
      },
    });
  },

  DeleteBolParaAgreement(token, agreementID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_REMOVE_BOL_PARA_AGREEMENT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        agreementID: agreementID,
      },
    });
  },

  UpdateBolParaCampaign(
    token,
    campaignID,
    title,
    prefix,
    companyID,
    description,
    images,
    start,
    end,
    type,
    allowedPoints,
    hasForm
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_UPDATE_BOL_PARA_CAMPAIGN}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
        title: title,
        prefix: prefix,
        companyID: companyID,
        description: description,
        images: images,
        start: start,
        end: end,
        type: type,
        allowedPoints: allowedPoints,
        hasForm,
      },
    });
  },

  RemoveBolParaCampaign(token, campaignID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_UPDATE_BOL_PARA_CAMPAIGN}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
        status: false,
      },
    });
  },

  GetBolParaResponses(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_BOL_PARA_RESPONSES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetBolParaResponsesWithPoi(token, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_BOL_PARA_RESPONSES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        poiID: poiID,
      },
    });
  },

  UpdateBolParaResponse(token, responseID, status) {
    console.log(token);
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_UPDATE_BOL_PARA_RESPONSE_STATUS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        responseID: responseID,
        status: status,
      },
    });
  },

  GetCampaigns(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_CAMPAIGNS_GET_CAMPAIGNS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        audiences: ['esnaf', 'easypoint', 'personal-customers'],
        allCampaigns: true,
      },
    });
  },

  CreateCampaign(
    token,
    title,
    description,
    start,
    end,
    images,
    link,
    targetAudience,
    hasForm,
    selectedFormID
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_CAMPAIGNS_CREATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        description: description,
        targetAudience: targetAudience,
        start: start,
        end: end,
        link: link,
        images: images,
        hasForm,
        selectedFormID,
      },
    });
  },
  UpdateCampaign(
    token,
    campaignID,
    title,
    description,
    start,
    end,
    images,
    link,
    targetAudience,
    status,
    hasForm,
    selectedFormID
  ) {
    console.log('service form id:', hasForm, selectedFormID);
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_CAMPAIGNS_UPDATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
        title: title,
        description: description,
        targetAudience: targetAudience,
        start: start,
        end: end,
        link: link,
        images: images,
        status: status,
        hasForm,
        selectedFormID,
      },
    });
  },
  GetArasKargoEcommerceCompanyList(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_ARAS_KARGO_GET_ECOMMERCE_COMPANY_LIST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  AcceptArasKargoEcommerceReturn(token, accountID, orderCode, prePrintBarcode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_ARAS_KARGO_ECOMMERCE_RETURN_ACCEPT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        accountID: accountID,
        orderCode: orderCode,
        prePrintBarcode: prePrintBarcode,
      },
    });
  },
  ArasKargoDropOffQrCheck(token, deliveryCode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_ARAS_KARGO_DROP_OFF_QR_CHECK}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        deliveryCode: deliveryCode,
      },
    });
  },
  ArasKargoDropOffAccept(token, deliveryCode, prePrintBarcode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_ARAS_KARGO_DROP_OFF_ACCEPT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        deliveryCode: deliveryCode,
        prePrintBarcode: prePrintBarcode,
      },
    });
  },
  GetArasKargoPosts(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_POSTS_GET}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: [9],
        withPosts: false,
      },
    });
  },
  ReturnArasKargoPost(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_POSTS_CHANGE_STATUS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: [
        {
          postID: postID,
          status: 40,
        },
      ],
    });
  },
  ReturnShopifyPost(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_POSTS_CHANGE_STATUS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: [
        {
          postID: postID,
          status: 45,
        },
      ],
    });
  },

  ChangeShopifyPostStatusToWillReturn(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_POSTS_CHANGE_STATUS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: [
        {
          postID: postID,
          status: 9,
        },
      ],
    });
  },
  ResendArasKargoOTP(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_ARAS_KARGO_SEND_OTP}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
      },
    });
  },
  ArasKargoPostComplete(token, barcode, customerNameLastname, otp) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_POSTS_COMPLETE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
        customerNameLastname: customerNameLastname,
        otpType: 'ArasKargoOTP',
        otp: otp,
      },
    });
  },
  GetDropboxListByLocations(token, locationCode, startDate, endDate) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DROP_BOX_LIST_BY_LOCATION_CODE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  DeliverPostWithTC(token, postID, tckn) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DELIVER_POST_WITH_TCKN}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
        tckn: tckn,
      },
    });
  },

  DeliverPostWithTC(token, postID, tckn) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DELIVER_POST_WITH_TCKN}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
        tckn: tckn,
      },
    });
  },
  DeliverManually(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DELIVER_POST_MANUALLY}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
      },
    });
  },
  GetStatusList(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_POST_STATUSES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  SetInBranchFromOnPorter(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_SET_IN_BRANCH_FROM_ON_PORTER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
      },
    });
  },
  GetCities() {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_CITIES}`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
  GetTowns(cityCode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_TOWNS}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        cityCode: cityCode,
      },
    });
  },
  GetRegions(townCode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_DISTRICTS}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        townCode: townCode,
      },
    });
  },
  GetLockerLocations() {
    return axios({
      method: 'get',
      url: `https://api.easypoint.com.tr/LockerTrack/locations`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  GetLockers(locationCode) {
    return axios({
      method: 'get',
      url: `https://api.easypoint.com.tr/LockerTrack/location/${locationCode}/lockers`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  LockerLoad(qrCode) {
    return axios({
      method: 'post',
      url: `https://api.easypoint.com.tr/LockerTrack/loadLocker`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        qrCode,
      },
    });
  },
  FinishBox(qrCode) {
    return axios({
      method: 'post',
      url: `https://api.easypoint.com.tr/LockerTrack/finishBox`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        qrCode,
      },
    });
  },

  GetPostLogsSearch(token, barcode, type, createdBy, startDate, endDate, log) {
    const data = {};
    if (barcode) data.barcode = barcode;
    if (type) data.type = type;
    if (createdBy) data.createdBy = createdBy;
    if (startDate) data.startDate = startDate;
    if (endDate) data.endDate = endDate;
    if (log) data.log = log;

    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_EASYPOINT_POST_LOGS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },
  GetPostLogsTypes(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_EASYPOINT_POST_LOG_TYPES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  CheckEasypointCenterDuplicate(token, field, value) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CHECK_EASYPOINT_CENTER_DUPLICATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        field,
        value,
      },
    });
  },

  CreateOperationReport(token, data, operationType) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CREATE_OPERATION_REPORT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        operationType: operationType,
        data: data,
      },
    });
  },

  GetOperationReport(token, operationType, startDate, endDate) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_OPERATION_REPORT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        operationType: operationType,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  UpdateOperationReport(token, data, operationType) {
    console.log({ operationType, data });
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_UPDATE_OPERATION_REPORT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        operationType: operationType,
        data: data,
      },
    });
  },

  TakeEcommerce(token, easypointID, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_ARAS_KARGO_MANAGER_PACKAGE_APPROVE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
        easypointID: easypointID,
      },
    });
  },

  DHLPackageApprove(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DHL_PACKAGE_APPROVE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
      },
    });
  },

  // Gönderiyi ödendi (isPaid: 1) ya da ödenmedi (isPaid: 0) olarak işaretler.
  // İşlemi yapan kullanıcı, IP ve saat backend'de kaydedilir. Gönderi zaten
  // istenen durumdaysa hata döner.
  SetDHLShipmentPaid(token, shipmentTrackingNumber, isPaid = 1) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/dhl-set-shipment-paid`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { shipmentTrackingNumber, isPaid },
    });
  },

  // DHL gönderilerini listeler. Filtrelerin hepsi opsiyonel:
  // { poiID, isPaid, startDate, endDate, limit, shipmentTrackingNumber, orderNumber }
  // shipmentTrackingNumber veya orderNumber ile tekil arama yapılabilir.
  GetDHLShipments(token, filters = {}) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/dhl-get-shipments`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: filters,
    });
  },

  DHLDropOffAccept(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DHL_DROP_OFF_ACCEPT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
      },
    });
  },

  GetVideos(token, type) {
    console.log('type video: ', type);
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_TRAINING_VIDEOS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: type,
      },
    });
  },

  GetDocuments(token, type) {
    console.log('type doc: ', type);
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_TRAINING_DOCUMENTS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: type,
      },
    });
  },

  GetFaq(token, type) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_FAQ}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: type,
      },
    });
  },

  CreateFaq(token, faq) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CREATE_FAQ}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: faq.title,
        description: faq.description,
        type: faq.type,
      },
    });
  },

  UpdateFaq(token, id, title, description, type) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_UPDATE_FAQ}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id,
        title,
        description,
        type,
      },
    });
  },

  RemoveFaq(token, id) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_REMOVE_FAQ}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id,
      },
    });
  },

  GetKidCarOrders(token, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYDESK_LIST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: 'kid-car',
        poiID: poiID,
      },
    });
  },

  GetPetCarOrders(token, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYDESK_LIST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: 'pet-car',
        poiID: poiID,
      },
    });
  },
  GetGiftOrders(token, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYDESK_LIST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: 'gift',
        poiID: poiID,
      },
    });
  },
  GetVehicleInventory(token, mallID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYDESK_GET_VEHICLE_INVENTORY}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID: mallID,
      },
    });
  },

  GetPoiDetails(token, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYDESK_GET_POI_DETAILS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        poiID: poiID,
      },
    });
  },

  UpdatePaymentIDForPhysicalPayment(token, requestId, paymentId) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYDESK_UPDATE_PAYMENT_ID}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        requestID: requestId,
        paymentID: paymentId,
      },
    });
  },

  VehiclesApproveRequest(token, requestID, poiID, vehicleID, color) {
    console.log(token, requestID, poiID, vehicleID, color);

    let payload = {
      requestID: requestID,
      poiID: poiID,
    };

    if (vehicleID) {
      payload.vehicleID = vehicleID;
    }
    if (color) {
      payload.color = color;
    }
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYDESK_APPROVE_REQUEST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: payload,
    });
  },

  GetEmanetReports(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DROPBOX_REPORT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        getCached: true,
      },
    });
  },

  GetEPAppPosts(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_POSTS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        dataEntranceType: 'Easypoint APP API',
        limit: 20000,
      },
    });
  },

  PetKidSetRequestComplete(token, requestID, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYDESK_SET_COMPLETED_REQUEST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        requestID,
        poiID,
      },
    });
  },

  DHLSendSign(barcode, dhlCustomerSign) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_DHL_SEND_SIGN}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        barcode,
        dhlCustomerSign,
      },
    });
  },

  DHLCustomerRefuse(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DHL_CUSTOMER_REFUSE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode,
      },
    });
  },

  SendPushNotification(users, title, body) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_SEND_PUSH_NOTIFICATION_WITH_USER_LIST}`,
      data: {
        users: users,
        title: title,
        body: body,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  // Bildirimleri getirir
  GetUserNotifications(userID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_USER_NOTIFICATIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  // Bildirimi okundu  işaretler

  SetReadNotification(notificationID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_SET_READ_NOTIFICATION}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        notificationID: notificationID,
        // Test için userID: "40613899664292277710",
      },
    });
  },

  CancelCheckRoom(checkroomID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CHECKROOM_CANCEL}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        checkroomID,
      },
    });
  },

  GetEPServices(token, startDate, endDate) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_EASYPOINT_SERVICES_REPORT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        startDate,
        endDate,
      },
    });
  },

  GetMalls(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_MALLS_GET_MALLS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        withOffices: true,
      },
    });
  },

  GetMall(token, mallID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_MALLS_GET_MALL}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },

  UpdateMallInventory(token, mallID, vehicleInventoryWithPrice) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_MALLS_UPDATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id: mallID,
        vehicleInventoryWithPrice,
      },
    });
  },

  UpdateMallVehicleInventory(token, mallID, vehicleInventory) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_MALLS_UPDATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id: mallID,
        vehicleInventory,
      },
    });
  },

  async getPrims(startDate, endDate, poiID) {
    const token = localStorage.getItem('tokenForService');
    const data = {
      startDate,
      endDate,
    };
    if (poiID) {
      data.poiID = poiID;
    }
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_ESNAF_PRIMS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },

  async calculateVigoPrice(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CALCULATE_VIGO_PRICE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },

  async createVigoPost(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CREATE_VIGO_POST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },
  async GetThirdPartyCargoCourierPosts(pointID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_THIRD_PARTY_CARGO_COURIER_POSTS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: '',
    });
  },

  ListenPayment(conversationID) {
    return axios({
      method: 'post',
      url: `${PAYMENT_API_URL}${process.env.REACT_APP_PAYMENT_ENDPOINT_FLOW_LISTEN}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        conversationID,
        id: '990366758347445860982942940743',
      },
    });
  },

  PaymentWith3D(
    conversationID,
    price,
    name,
    lastname,
    phone,
    holderName,
    cardNumber,
    expYear,
    expMonth,
    cvc
  ) {
    return axios({
      method: 'post',
      url: `${PAYMENT_API_URL}${process.env.REACT_APP_PAYMENT_ENDPOINT_FLOW_PAYMENT_WITH_3D}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        id: '990366758347445860982942940743',
        conversationID: conversationID,
        totalPrice: price,
        paidPrice: price,
        discount: 0,
        installment: 1,
        currency: 'TRY',
        customer: {
          name: name,
          lastname: lastname,
          phone: phone,
        },
        creditCardInfos: {
          holderName: holderName,
          cardNumber: cardNumber,
          expYear: expYear,
          expMonth: expMonth,
          cvc: cvc,
        },
        willBeStored: false,
        cardAlias: false,
        items: [
          {
            name: 'Vigo Motor Courier',
            price: price,
          },
        ],
        callback:
          'http://localhost:8888/craftgate-3ds-html-content.php?id=23469234827364982',
      },
    });
  },

  GetPaymentError(conversationID) {
    return axios({
      method: 'post',
      url: `${PAYMENT_API_URL}${process.env.REACT_APP_PAYMENT_ENDPOINT_FLOW_GET_PAYMENT_ERROR}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        conversationID,
        id: '990366758347445860982942940743',
      },
    });
  },
  SetPaid(requestID, paymentID, last4Digit) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYDESK_SET_PAID}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        requestID: requestID,
        paymentID: paymentID,
        creditCardLast4Digit: last4Digit,
        id: '990366758347445860982942940743',
      },
    });
  },

  // Ülkenin bölgeleri (Türkiye'de il, ABD'de eyalet). Varsayılan limit 200.
  GetPostalCodeRegions({ countryCode, search, limit = 200 }) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/postal-codes-get-regions`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { countryCode, search, limit },
    });
  },

  // DHL Address Validate: yazılan harflerle başlayan, DHL'in tanıdığı şehirleri döndürür
  // ("Dub" -> DUBAI, DUBAI HILLS ...). type: pickup (gönderici) | delivery (alıcı).
  // Eşleşme yoksa status: false döner.
  DHLValidateAddress({ type, countryCode, cityName }) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/dhl-validate-address`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { type, countryCode, cityName },
    });
  },

  // Şehir/semt listesi. region ve search opsiyonel. Varsayılan limit 200.
  GetPostalCodeCities({ countryCode, region, search, limit = 200 }) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/postal-codes-get-cities`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { countryCode, region, search, limit },
    });
  },

  // Posta kodu verisi bulunan ülkeler.
  GetPostalCodeCountries() {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/postal-codes-get-countries`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {},
    });
  },

  async GetDHLCargoRates(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DHL_GET_CARGO_RATES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },
  async CreateDHLCargo(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DHL_CREATE_CARGO}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },

  async GetPLTCountries({ countryCode, declaredValue, declaredValueCurrency }) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/dhl-get-plt-countries`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { countryCode, declaredValue, declaredValueCurrency },
    });
  },

  AddCampaignForm(
    token,
    campaignID,
    title,
    formElements,
    description,
    legalContent
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CAMPAIGNS_ADD_FORM}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID,
        title,
        formElements,
        description,
        legalContent,
      },
    });
  },

  GetCampaignForms(token, campaignID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CAMPAIGNS_GET_FORM}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID,
      },
    });
  },

  GetCampaignForm(token, campaignID, formID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CAMPAIGNS_GET_FORM}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID,
        formID,
      },
    });
  },

  RemoveCampaignForm(token, formID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CAMPAIGNS_REMOVE_FORM}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        formID,
      },
    });
  },

  UpdateCampaignForm(
    token,
    campaignID,
    title,
    formElements,
    description,
    legalContent,
    formID
  ) {
    console.log({
      campaignID,
      title,
      formElements,
      description,
      legalContent,
      formID,
    });
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CAMPAIGNS_UPDATE_FORM}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID,
        title,
        formElements,
        description,
        legalContent,
        formID,
      },
    });
  },

  AddCampaignQuestion(token, question) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CAMPAIGNS_CREATE_FORM_QUESTION}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        content: question,
      },
    });
  },

  UpdateCampaignQuestion(token, questionID, content) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CAMPAIGNS_UPDATE_FORM_QUESTION}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        questionID,
        content,
      },
    });
  },

  RemoveCampaignQuestion(token, questionID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CAMPAIGNS_UPDATE_FORM_QUESTION}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        questionID,
        status: '0',
        content: {},
      },
    });
  },

  GetCampaignQuestions(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CAMPAIGNS_GET_FORM_QUESTIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  SubmitCampaignForm(token, data, formID, campaignID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CREATE_CAMPAIGN_FORM_RESULT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        data,
        type: 'campaign-form',
        formID,
        campaignID,
      },
    });
  },

  async ChangeCancelOrderStatus(barcodeList) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_MASS_POST_DELIVER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcodes: barcodeList,
      },
    });
  },
  GetSubmittedCampaignForms(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_CAMPAIGN_FORM_RESULTS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: 'campaign-form',
      },
    });
  },
  CreateBolparaCoupon(
    token,
    companyID,
    isCompanyBased,
    isCampaignBased,
    campaignID,
    couponCodes,
    isOneTime,
    expiredDateTime,
    description
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_BOL_PARA_CREATE_DISCOUNT_COUPONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID,
        isCompanyBased,
        isCampaignBased,
        campaignID,
        couponCodes,
        isOneTime,
        expiredDateTime,
        description,
      },
    });
  },
  GetBolparaCoupons(token, companyID, campaignID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_BOL_PARA_GET_DISCOUNT_COUPONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID,
        campaignID,
      },
    });
  },
  CancelUnusedBolparaCoupons(token, companyID, campaignID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_BOL_PARA_CANCEL_UNUSED_DISCOUNT_COUPONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID,
        campaignID,
      },
    });
  },
  CancelSingleUnusedBolparaCoupon(token, couponID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_BOL_PARA_CANCEL_DISCOUNT_COUPON}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        couponID,
      },
    });
  },
  UseSingleBolparaCoupon(token, companyID, coupon) {
    console.log(companyID);
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_BOL_PARA_SET_DISCOUNT_COUPONS_AS_USED}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID,
        coupons: [coupon],
      },
    });
  },
  UseBolparaCoupons(token, companyID, coupons) {
    console.log(companyID);
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_BOL_PARA_SET_DISCOUNT_COUPONS_AS_USED}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID,
        coupons,
      },
    });
  },
  async GetDropboxLocations() {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DROP_BOX_GET_LOCATIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  async GetDropboxAllTransactions(locationCode, startDate, endDate) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DROPBOX_GET_TRANSACTIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  async GetDropboxLockerLocations() {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_LOCKERS_GET_LOCATIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  async GetDropboxLocationDuration(locationCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DROP_BOX_GET_LOCATION_DURATION}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode,
      },
    });
  },
  async GetDropboxLockersGetLockers(locationCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_LOCKERS_GET_LOCKERS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode,
      },
    });
  },
  async GetDropboxLockersGetLockersDurations(locationCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_LOCKERS_GET_DURATIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode,
      },
    });
  },
  async GetLocationSettings(locationCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DROP_BOX_GET_LOCATION_SETTINGS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode,
      },
    });
  },
  async MakeReloadBox(sessionId) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DROPBOX_RELOAD_BOX}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        sessionID: sessionId,
      },
    });
  },

  async updateLocationSettings(settingsData) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DROP_BOX_UPDATE_LOCATION_SETTINGS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: settingsData,
    });
  },
  async GetAllDropBoxCampaignCoupons(location) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'get',
      url: `https://api.easypoint.com.tr/campaign`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {},
    });
  },
  async CreateDropBoxCampaign(couponData) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: 'https://api.easypoint.com.tr/campaign',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: couponData,
    });
  },
  async DeleteDropBoxCampaign(couponID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DROP_BOX_REMOVE_COUPON}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        couponID,
      },
    });
  },
  async createCargoistPost(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_KARGOIST_CREATE_CARGO}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },
  async BoxOperationSendingSMS(phoneNumber, message) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `https://api.easypoint.com.tr/other-services/box-sms`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        phoneNumber: phoneNumber,
        message: message,
        validationCode: 'EasyPointSmsSender',
      },
    });
  },

  FormResultChangeStatus(token, requestID, status) {
    console.log(requestID, status);
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CAMPAIGN_FORM_RESULT_CHANGE_STATUS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        requestID,
        status,
      },
    });
  },

  ContactFormResultChangeStatus(token, requestID, status) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CONTACT_FORM_CHANGE_STATUS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        requestID,
        status,
      },
    });
  },
  GetBolParaCompanyHasCoupon(token, companyID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_BOL_PARA_HAS_COUPON}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID,
      },
    });
  },

  GetNewCompanyCoupon(token, companyID, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_BOL_PARA_GET_NEW_COUPON}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID,
        viewedType: 'esnaf',
        poiID,
      },
    });
  },

  GetContactFormResults(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_CONTACT_FORMS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  // GetContactFormResults(token) {
  //   return axios({
  //     method: "post",
  //     url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_CONTACT_FORMS}`,
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     }
  //   });
  // },

  async makeDropboxEmpty(sessionID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EMPTY_DROP_BOX}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        sessionID: sessionID,
      },
    });
  },

  async getDropboxStatuses(locationCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_LOCATION_POST_BOXES_STATUSES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode,
      },
    });
  },
  async DropboxCheckLocker(checkLockerData) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DROP_BOX_CHECK_LOCKER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: checkLockerData,
    });
  },
  async MakeRentalLoad(payload) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_LOAD_LOCKER}`,
      headers: {
        // Authorization: `Bearer ${token}`,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: payload,
    });
  },
  async FinishRentalLoad(qrCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_FINISH_BOX}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        qrCode: qrCode,
      },
    });
  },

  async GetContactForms() {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_GET_CONTACT_FORMS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetBolParaCampaignHasCoupon(token, campaignID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_BOL_PARA_HAS_COUPON}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID,
      },
    });
  },

  GetNewCampaignCoupon(token, companyID, campaignID, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_BOL_PARA_GET_NEW_COUPON}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID,
        campaignID,
        viewedType: 'esnaf',
        poiID,
      },
    });
  },

  CreateBolParaQRShowLog(token, campaignID, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_CREATE_BOL_PARA_QR_SHOW_LOG}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID,
        poiID,
      },
    });
  },

  EPCentersSetClosedDates(token, easypointIDs, closedDateStart, closedDateEnd) {
    console.log({ easypointIDs, closedDateStart, closedDateEnd });
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYPOINT_CENTERS_SET_CLOSED_DATES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        easypointIDs,
        closedDateStart,
        closedDateEnd,
      },
    });
  },

  EPPetCreateSingleCoupon(
    token,
    title,
    mallID,
    discountForProduct,
    startDate,
    expireDate,
    discountType,
    discountValue,
    inventory,
    couponCode
  ) {
    console.log({
      title,
      mallID,
      discountForProduct,
      startDate,
      expireDate,
      discountType,
      discountValue,
      inventory,
      couponCode,
    });
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYDESK_CREATE_COUPON}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title,
        mallID,
        discountForProduct,
        startDate,
        expiredDate: expireDate,
        discountType,
        discountValue,
        inventory,
        couponCode,
      },
    });
  },

  EPPetCreateMassCoupons(
    token,
    title,
    mallID,
    discountForProduct,
    startDate,
    expireDate,
    discountType,
    discountValue,
    count
  ) {
    console.log({
      title,
      mallID,
      discountForProduct,
      startDate,
      expireDate,
      discountType,
      discountValue,
      count,
    });
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYDESK_CREATE_MASS_COUPONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title,
        mallID,
        discountForProduct,
        startDate,
        expiredDate: expireDate,
        discountType,
        discountValue,
        count,
      },
    });
  },
  GetEasydeskCouponList(token, mallID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_EASYDESK_GET_COUPON_LIST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },

  DHLReturnComplete(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_DHL_RETURN_COMPLETE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
      },
    });
  },
  GetSuratCargoEcommerceCompanyList(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_SURAT_KARGO_GET_ECOMMERCE_COMPANY_LIST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  AcceptSuratCargoEcommerceReturn(
    token,
    orderNumber,
    marketplaceID,
    preprintedBarcodeNumber
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_FLOW_SURAT_KARGO_ECOMMERCE_RETURN_ACCEPT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        orderNumber: orderNumber,
        marketplaceID: marketplaceID,
        preprintedBarcodeNumber: preprintedBarcodeNumber,
      },
    });
  },
  GetHandsFreeToken() {
    return axios({
      method: 'post',
      url: `${HANDSFREE_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_GET_TOKEN}`,
      data: {
        key: process.env.REACT_APP_ENDPOINT_HANDSFREE_KEY,
        secret: process.env.REACT_APP_ENDPOINT_HANDSFREE_SECRET,
      },
    });
  },
    // AVM'nin Hands Free özel teslimat siparişleri.
  GetMallsPrivateDeliveryOrders(token, mallID) {
    return axios({
      method: 'post',
      url: `${HANDSFREE_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_FLOW_GET_MALLS_PRIVATE_DELIVERY_ORDERS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },

  // Hands Free siparişini onaylar. Token Hands Free API'sinin kendi token'ıdır.
  ConfirmHandsFreeOrder(token, orderID) {
    return axios({
      method: 'post',
      url: `${HANDSFREE_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_FLOW_ORDER_CONFIRM}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        orderID,
        count: false,
      },
    });
  },

  // Hands Free siparişini reddeder.
  RejectHandsFreeOrder(token, orderID) {
    return axios({
      method: 'post',
      url: `${HANDSFREE_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_FLOW_ORDER_REJECT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        orderID,
      },
    });
  },
};
